import { Subscription } from 'rxjs';
import { htmlUrls } from '@shared/utils/router-paths';
import { EImageType } from '@shared/pipes/image.pipe';
import { BaseComponent } from '../base/base.component';
import { SharedModule } from '@shared/module/shared.module';
import { IPostModel } from '@app/pages/posts/models/post.model';
import { LocalRepository } from '@shared/helper/local-repository';
import { EBookState } from '@app/pages/books/models/book-state.enum';
import {  Router, RouterLink } from '@angular/router';
import { bookViewModel } from '@shared/model/new-models/book-view-model';
import { AuthorSortPipe } from '@shared/pipes/author-type/author-sort.pipe';
import { ProgressBarComponent } from '../progress-bar/progress-bar.component';
import { TermFilterModel } from '@shared/model/categoryAndSearch/term-filter-model';
import { BookShelfModel, ChangeBookStateModel } from '@shared/model/bookModels/book-shelf.model';
import { ShelvesAggrigatorService } from '@app/pages/library/services/shelvesAggrigator.service';
import { ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit, Output, inject } from '@angular/core';
import { PostSuggesteItemComponent } from '@app/pages/posts/components/post-suggeste-item/post-suggeste-item.component';
import { AuthorTypePipe } from '@shared/pipes/author-type/author-type.pipe';

@Component({
    selector: 'app-home-currently-reading',
    templateUrl: './home-currently-reading.component.html',
    styleUrls: ['./home-currently-reading.component.scss'],
    imports: [
        SharedModule,
        AuthorSortPipe,
        ProgressBarComponent,
        PostSuggesteItemComponent,
        RouterLink,
        AuthorTypePipe
    ]
})
export class HomeCurrentlyReadingComponent extends BaseComponent implements OnInit, OnDestroy {
  private router = inject(Router);
  private cdr = inject(ChangeDetectorRef);
  _localRepository = inject(LocalRepository);
  private shelvesAggrigatorService = inject(ShelvesAggrigatorService);

  routes = htmlUrls;
  allBooksCount!: number;
  bookState = EBookState;
  loading = true;
  books: bookViewModel[] = [];
  bookShelf: BookShelfModel = new BookShelfModel();
  currentlyTermFilter: TermFilterModel = new TermFilterModel();
  changeBookState: ChangeBookStateModel = new ChangeBookStateModel();

  loadingNewBooks = false;

  imageType = EImageType;

  @Output() closeBottomSheet = new EventEmitter<boolean>();
  hasMoreCurrentlyReadingBooks!: boolean;

  inPostPage!: boolean;
  gettingPostData = true;
  guestPosts: IPostModel[] = [];
  suggestedPosts: IPostModel[] = [];

  routeSubscription!: Subscription;

  constructor() {
    super();
    this.currentlyTermFilter.pgSize = 3;
    this.currentlyTermFilter.pgNumber = 0;
  }

  ngOnInit(): void {
    this.getPostData();

    this.shelvesAggrigatorService.getCurrentlyReadingUserLib(this.currentlyTermFilter)
      .subscribe(res => {
        if (!res.hasError) {
          this.books = res?.result?.items;
          this.hasMoreCurrentlyReadingBooks = res.result?.hasNextPage;
          this.allBooksCount = res?.result?.totalCount;
        }
        else {
          this.books = [];
          this.hasMoreCurrentlyReadingBooks = false;
        }
        this.loading = false;
      });

    this.appStateService.currentlyReadingNotifier$.subscribe((res: bookViewModel) => {
      if (res?.id) {
        if (res.state === EBookState.CurrentlyReading) {
          const existBook = this.books.find(book => book.id === res.id);
          // ? Just Update steps -- This book exist in the list
          if (existBook) {
            existBook.state = res.state;
            existBook.steps = res.steps;
          }
          else {
            this.books.unshift(res)
          }

          this.cdr.detectChanges();
        }
        else {
          const existBookIndex = this.books.findIndex(book => book.id === res.id);
          if (existBookIndex > -1) {
            this.books.splice(existBookIndex, 1);
            this.cdr.detectChanges();
          }
        }
      }
    });
  }

  getPostData() {
    this.routeSubscription =
      this.appStateService.otherPosts
        .subscribe(res => {
          if (res?.inPost) {
            this.inPostPage = true;
            this.suggestedPosts = res.suggested;
            this.guestPosts = res.userPosts;
            this.gettingPostData = false;
            this.cdr.detectChanges();
          }
          else {
            this.inPostPage = false;
          }
        });
  }

  loadMoreBooks() {
    this.loadingNewBooks = true;
    this.currentlyTermFilter.pgNumber++;
  }

  trackBooks(_index: number, item: bookViewModel) {

    return item;
  }

  close(book: bookViewModel) {
    // TODO : Open Dialog for Reading Progress
    this.router.navigate([this.routes.history, book.id,], { queryParams: { user: this.currentUser?.uniqeName } })
    if (this._localRepository.IsInMobile) {
      this.closeBottomSheet.emit()
    }
  }
}
